// HAMBURGER ICON

const hamburgers = document.querySelectorAll('.hamburger');
const mobileMenu = document.querySelector('.mobile-menu');
const mobileMenuLinks = document.querySelectorAll('.mobile-menu a, .hamburger');

mobileMenuLinks.forEach(mobileMenuLink => {
  mobileMenuLink.onclick = () => {
    hamburgers.forEach(element => {
      element.classList.toggle('is-active');
    });
    mobileMenu.classList.toggle('open');
  };
});
